const n="\n  amount\n  currencyCode\n";export{n as STOREFRONT_PRICE_FRAGMENT};
//# sourceMappingURL=price.js.map
